import { Holding } from '@daml.js/dtc-registry-holding/lib/Dtc/Registry/Holding/V3/Holding';
import TemplateContract from './TemplateContract';

type Args = {
  owner: string;
  holdings: TemplateContract<Holding>[];
};
export const filterHoldingsByOwner = (arg: Args) => {
  const { owner, holdings } = arg;
  return holdings.filter((h) => h.payload.owner === owner);
};
